import BaseTableReport from 'components/atoms/base-table/report/report';
import { useLinkCallReadingsToolFilters } from 'infrastructure/hooks/link-call-readings-tool/use-link-call-readings-tool-filter';
import {
  LINK_CALL_READINGS_PER_PAGE,
  useGetLinkCallReadingsToolData,
} from 'infrastructure/hooks/link-call-readings-tool/use-get-data';
import { useTranslation } from 'react-i18next';
import { type FC } from 'react';

import { useColumns } from './use-columns';

interface LinkCallReadingsTableProps {}

const LinkCallReadingsTable: FC<LinkCallReadingsTableProps> = () => {
  const { data, isLoading } = useGetLinkCallReadingsToolData();
  const { filter, updateFilter } = useLinkCallReadingsToolFilters();
  const { t } = useTranslation();

  const columns = useColumns();

  return (
    <>
      <BaseTableReport
        rowKey="callId"
        isLoading={isLoading}
        columns={columns}
        headerTitle={t('labels.calls')}
        dataSource={data?.data}
        pagination={{
          current: filter.page,
          pageSize: LINK_CALL_READINGS_PER_PAGE,
          total: data?.count,
          onChange: (page) => updateFilter({ page }),
        }}
        showCount
        anchor
      />
    </>
  );
};
export default LinkCallReadingsTable;
